import React from 'react';
import { Flex } from 'antd';
import { resolveIana } from '@/pages/Logiblocks/dateTimeUtils';
import EntryChipList from './EntryChipList';
import SelectedEntriesHeader from './SelectedEntriesHeader';
import { DateSetValue } from './dateSetTypes';
import { dateChipConfig, dayChipConfig } from './dateSetUtils';

interface DateSetEntriesSectionProps {
  value: DateSetValue;
  onChange: (value: DateSetValue) => void;
  disabled?: boolean;
}

/** A set's "Selected dates/days (N)" header with its timezone selector, and
 * the entries as chips — the part of the save-list and list-edit panels that
 * shows and edits a set's contents. */
const DateSetEntriesSection: React.FC<DateSetEntriesSectionProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const { entries } = value;
  return (
    <Flex vertical gap={12}>
      <SelectedEntriesHeader
        kind={entries.kind}
        count={entries.entries.length}
        timezoneValue={{ type: 'timezone', value: value.ianaTimezone }}
        onTimezoneChange={(sel) =>
          onChange({
            ...value,
            ianaTimezone: resolveIana(sel),
          })
        }
      />
      {entries.kind === 'dates' ? (
        <EntryChipList
          entries={entries.entries}
          {...dateChipConfig}
          onChange={(next) =>
            onChange({ ...value, entries: { kind: 'dates', entries: next } })
          }
          disabled={disabled}
        />
      ) : (
        <EntryChipList
          entries={entries.entries}
          {...dayChipConfig}
          onChange={(next) =>
            onChange({
              ...value,
              entries: { kind: 'daysOfWeek', entries: next },
            })
          }
          disabled={disabled}
        />
      )}
    </Flex>
  );
};

export default DateSetEntriesSection;
